import { useRef, useEffect } from 'react';
import styles from './PromptCard.module.css';

export default function PromptCard({ category, promptText, value, onChange, onBlur, locked }) {
  const textareaRef = useRef(null);

  useEffect(() => {
    const el = textareaRef.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }, [value]);

  return (
    <div
      className={styles.card}
      style={{ '--accent': `var(${category.accentVar})` }}
    >
      <div className={styles.header}>
        <span className={styles.icon}>{category.icon}</span>
        <span className={styles.label}>{category.label}</span>
      </div>
      <p className={styles.prompt}>{promptText}</p>
      {locked ? (
        <p className={styles.response}>{value || <em className={styles.empty}>No response</em>}</p>
      ) : (
        <textarea
          ref={textareaRef}
          className={styles.textarea}
          placeholder={category.placeholder}
          value={value}
          onChange={e => onChange(e.target.value)}
          onBlur={onBlur}
          rows={2}
        />
      )}
    </div>
  );
}
